import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// permissaoUsuario.service.js — r87 (Rodada C)
// ────────────────────────────────────────────────────────────────────────────
// Consulta as permissões resolvidas de um usuário logado.
// ════════════════════════════════════════════════════════════════════════════

const permissaoUsuarioService = {
  // GET /api/usuarios/:id/permissoes-resolvidas
  resolverPermissoes: async (usuarioId) => {
    const res = await api.get(`/usuarios/${usuarioId}/permissoes-resolvidas`,
      { params: { _t: Date.now() } });   // anti-cache
    return res.data;
    // Estrutura:
    // {
    //   versao: 17,
    //   admin: false,
    //   bootstrap: false,
    //   grupo_id: 'ABC123',
    //   rotinas: {
    //     'usuarios': { 'visualizar': { permitido: true }, ... },
    //     'lancamentos-horas': { 'visualizar': { permitido: true, filtro: 'meu_colaborador' }, ... },
    //   }
    // }
  },
};

export default permissaoUsuarioService;
